const converterTributo = document.getElementById('fazer-tributo-conciliavel');
const GlobalAlerts = require('../functions/GlobalAlerts');
const Lang = require('lang');

function init() {
  if (converterTributo) {
    converterTributo.addEventListener('click', confirmarTransformarTributoEmConciliacao);
  }
}

function confirmarTransformarTributoEmConciliacao() {
  const tributeId = $(this).data('item-fatura-id');

  $.ajax({
    url: route('app.admin.conciliacoes.fazer-tributo-conciliavel', tributeId),
    method: 'POST',
  }).then(() => {
    window.location.reload();
  }).catch((error) => {
    GlobalAlerts.createAndShow({
      type: 'danger',
      title: Lang.get('js/common/phrases.ops'),
      message: error.responseJSON.message,
    })
  });
}

module.exports = {
  init: init,
  url: /admin\/conciliacoes\/encerrar-fatura\/\d+/
};
